import { useEffect, useState } from "react";
import { useStores } from "../../store";
import Select from "../JobPost/Select";
import Input from "../JobPost/input";
import { AiOutlineLeft } from "react-icons/ai";
import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
import { MdDeleteOutline, MdOutlineAddCircleOutline } from "react-icons/md";
import { useObserver } from "mobx-react";
import Popup from "./Components/skipPopup";
import { getUserDataFromLocalStorage } from "../../services/localStorage";
import { apiPostPut } from "../../api/api_methods";
import { uploadFileToAzure } from "../../services/azure";
import Loader from "../reusble_components/loader";
import { interviewsProList } from "../../helpers/constantVariables";
import { getUserRoleFromLocalStorage } from "../../services/reusable";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import HelpCenter from "../reusble_components/helpCenter";
import JobShare from "./Components/Job";
import { useLocation } from "react-router-dom";
import PercentageInput from "../JobPost/PercentageInput";

export default function Technical({
  skip,
  fromIndex,
  interview,
  buttonName,
  isEdit,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const { CommonStore, RecuiterStore, InterviewStore, PopupStore } =
    useStores();
  const [waiting, setWaiting] = useState(false);
  const [showSkip, setShowSkip] = useState(skip ?? true);
  const [interviewType, setInterviewType] = useState(
    RecuiterStore.jobPostDetails.technicalInterviewDetails
      .technicalInterviewType || ""
  );
  const [noOfQuestions, setNoOfQuestions] = useState(
    RecuiterStore.jobPostDetails.technicalInterviewDetails
      .technicalNumberOfQuestions || ""
  );
  const [level, setLevel] = useState(
    RecuiterStore.jobPostDetails.technicalInterviewDetails
      .technicalInterviewLevel || ""
  );
  const [customQuestions, setCustomQuestions] = useState(
    RecuiterStore.jobPostDetails.technicalInterviewDetails
      .technicalCustomquestions || []
  );
  const [showPopup, setShowPopup] = useState(false);
  const [technology, setTechnology] = useState(
    RecuiterStore.jobPostDetails.technicalInterviewDetails.technology || ""
  );
  const [attempts, setAttempts] = useState(
    RecuiterStore.jobPostDetails.technicalInterviewDetails.additionalSettings
      .attempts || 1
  );
  const [noOfFollowupQuestions, setNoOfFollowupQuestions] = useState(
    RecuiterStore.jobPostDetails.technicalInterviewDetails.noOfFollowUps || ""
  );
  const [noOfIntroQuestions, setNoOfIntroQuestions] = useState(
    RecuiterStore.jobPostDetails.technicalInterviewDetails.noOfIntroQuestions ||
      ""
  );
  const [allQuestions, setAllQuestions] = useState(
    RecuiterStore.jobPostDetails.technicalInterviewDetails.allQuestions || ""
  );
  const [distOpen, setDistOpen] = useState(false);
  const [distTotal, setDistTotal] = useState(0);
  const [distTopic, setDistTopic] = useState(0);
  const [distIntro, setDistIntro] = useState(0);
  const [distFollow, setDistFollow] = useState(0);
  const [distCustom, setDistCustom] = useState(0);
  // Store original values to revert on cancel
  const [originalTopic, setOriginalTopic] = useState(0);
  const [originalIntro, setOriginalIntro] = useState(0);
  const [originalFollow, setOriginalFollow] = useState(0);
  const [noOfCustomQuestions, setNoOfCustomQuestions] = useState(
    RecuiterStore.jobPostDetails.technicalInterviewDetails
      .noOfCustomQuestions || "0"
  );
  const [invitationLink, setInvitationLink] = useState(null);
  const [clientLink, setClientLink] = useState(null);
  const [showLink, setShowLink] = useState(false);
  const [showCustom, setShowCustom] = useState(false);

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const id = query.get("id"); // id of the interview

  

  const setInterviewData = async () => {
    const res = await RecuiterStore.fetchInterviewDetails(id);
    if (res.status === 200) {
      setInterviewType(
        res.body.data.interviewId === 2 ? "AI interview" : "Manual interview"
      );

      setTechnology(res.body.data.technology);
      setLevel(res.body.data.levelOfInterview);
      setNoOfQuestions(res.body.data.noOfQuestions);
      setNoOfIntroQuestions(res.body.data.noOfIntroQuestions || 0);
      setNoOfFollowupQuestions(res.body.data.noOfFollowUps || 0);
      setAllQuestions(res.body.data.allQuestions || 0);
      setNoOfCustomQuestions(res.body.data.noOfCustomQuestions || "0");
      setCustomQuestions(res.body.data.customQuestions);
      setShowCustom(Number(res.body.data.noOfCustomQuestions || 0) > 0);
      setAttempts(res.body.data.customSettings[3].value);
      RecuiterStore.settechnicalAdditionalSettings(
        "camera",
        res.body.data.customSettings[0].value
      );
      RecuiterStore.settechnicalAdditionalSettings(
        "resume",
        res.body.data.customSettings[1].value
      );
      RecuiterStore.settechnicalAdditionalSettings(
        "screen",
        res.body.data.customSettings[2].value
      );
      RecuiterStore.setTechnicalInterviewDetails(
        "whoPayCheck",
        res.body.data.whoPay === "candidate" ? true : false
      );
      RecuiterStore.jobPostDetails.customSettings =
        res.body.data.customSettings;
    }
  };

  useEffect(() => {
    if (id && !window.location.pathname.includes("job-post")) {
      setInterviewData();
    }
  }, [id]);

  // Synchronize component state with store values on mount
  useEffect(() => {
    setInterviewType(
      RecuiterStore.jobPostDetails.technicalInterviewDetails
        .technicalInterviewType || ""
    );
    setNoOfQuestions(
      RecuiterStore.jobPostDetails.technicalInterviewDetails
        .technicalNumberOfQuestions || ""
    );
    setLevel(
      RecuiterStore.jobPostDetails.technicalInterviewDetails
        .technicalInterviewLevel || ""
    );
    setCustomQuestions(
      RecuiterStore.jobPostDetails.technicalInterviewDetails
        .technicalCustomquestions || []
    );
    setTechnology(
      RecuiterStore.jobPostDetails.technicalInterviewDetails.technology || ""
    );
    setAttempts(
      RecuiterStore.jobPostDetails.technicalInterviewDetails.additionalSettings
        .attempts || 1
    );
    setNoOfIntroQuestions(
      RecuiterStore.jobPostDetails.technicalInterviewDetails
        .noOfIntroQuestions || ""
    );
    setNoOfFollowupQuestions(
      RecuiterStore.jobPostDetails.technicalInterviewDetails.noOfFollowUps || ""
    );
    setAllQuestions(
      RecuiterStore.jobPostDetails.technicalInterviewDetails.allQuestions || ""
    );
    setNoOfCustomQuestions(
      RecuiterStore.jobPostDetails.technicalInterviewDetails
        .noOfCustomQuestions || "0"
    );
    setShowCustom(
      Number(
        RecuiterStore.jobPostDetails.technicalInterviewDetails
          .noOfCustomQuestions || 0
      ) > 0
    );
    console.log(
      RecuiterStore.jobPostDetails.technicalInterviewDetails
        .technicalInterviewType,
      "test"
    );
  }, []);

  const [popUpVisible, setPopupVisible] = useState(false);

  useEffect(() => {
    if (interviewType === "Manual interview") {
      const updateQuestionsArray = () => {
        if (noOfQuestions > 30)
          return alert(
            "Number of questions should be less than or equal to 30"
          );
        const updatedQuestionsArray = [...customQuestions];
        const currentLength = updatedQuestionsArray.length;
        const newLength = Number(noOfQuestions);

        if (newLength > currentLength) {
          for (let i = currentLength; i < newLength; i++) {
            updatedQuestionsArray.push("");
          }
        } else if (newLength < currentLength) {
          updatedQuestionsArray.length = newLength;
        }
        setCustomQuestions(updatedQuestionsArray);
        RecuiterStore.setTechnicalInterviewDetails(
          "technicalNumberOfQuestions",
          noOfQuestions
        );
      };
      if (noOfQuestions === "") {
        setCustomQuestions([]);
        return;
      }
      if (noOfQuestions && Number(noOfQuestions) !== customQuestions.length) {
        updateQuestionsArray();
      }
    }
  }, [noOfQuestions, interviewType]);

  useEffect(() => {
    // if (interviewType === "AI interview") {
    //   setCustomQuestions([]);
    //   setNoOfQuestions(0);
    // }
  }, [interviewType]);

  // Sync customQuestions array length with noOfCustomQuestions for AI interviews
  useEffect(() => {
    if (
      interviewType === "AI interview" &&
      Number(noOfCustomQuestions || 0) > 0
    ) {
      const customCount = Number(noOfCustomQuestions || 0);
      const currentLength = customQuestions.length;

      if (currentLength < customCount) {
        // Add empty strings to match the count
        const updated = [...customQuestions];
        for (let i = currentLength; i < customCount; i++) {
          updated.push("");
        }
        setCustomQuestions(updated);
      } else if (currentLength > customCount) {
        // Remove extra questions
        setCustomQuestions(customQuestions.slice(0, customCount));
      }
    } else if (
      interviewType === "AI interview" &&
      Number(noOfCustomQuestions || 0) === 0
    ) {
      // If noOfCustomQuestions is 0, clear custom questions
      if (customQuestions.length > 0) {
        setCustomQuestions([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [noOfCustomQuestions, interviewType]);

  const handleAddQuestion = () => {
    if (customQuestions.length >= 30) {
      return alert("Number of questions should be less than or equal to 30");
    }
    if (customQuestions.length >= 5 && interviewType === "AI interview") {
      return alert("Number of questions should be less than or equal to 5");
    }
    setCustomQuestions([...customQuestions, ""]);
    if (interviewType !== "AI interview") {
      setNoOfQuestions(customQuestions.length + 1);
    }
  };

  const handleRemoveQuestion = (index) => {
    setCustomQuestions(customQuestions.filter((_, i) => i !== index));
    RecuiterStore.setTechnicalInterviewDetails(
      "technicalCustomquestions",
      customQuestions.filter((_, i) => i !== index)
    );

    if (interviewType === "Manual interview") {
      setNoOfQuestions(customQuestions.length - 1);
    }
  };

  const getInterviewId = (interviewType) => {
    console.log(interviewType);
    const interviewId = interviewsProList.find(
      (interview) => interview.title === interviewType
    )?.interviewId;
    return interviewId;
  };

  const handlePopUpVisible = (value) => {
    setPopupVisible(value);
  };

  const handleTechnicalSubmit = (e) => {
    e.preventDefault();
    if (
      customQuestions.length + Number(noOfQuestions) > 20 &&
      interviewType === "AI interview"
    ) {
      console.log(customQuestions.length, noOfQuestions);
      alert(
        "Additional questions & Number of questions should be less than or equal to 20"
      );
      return;
    }

    // Validate custom questions for AI interviews
    if (
      interviewType === "AI interview" &&
      Number(noOfCustomQuestions || 0) > 0
    ) {
      const customCount = Number(noOfCustomQuestions || 0);

      // Check if length matches
      if (customQuestions.length !== customCount) {
        alert(
          `Please provide exactly ${customCount} custom question${
            customCount !== 1 ? "s" : ""
          }. Currently you have ${customQuestions.length} question${
            customQuestions.length !== 1 ? "s" : ""
          }.`
        );
        return;
      }

      // Check if all custom questions are filled
      const emptyIndices = [];
      customQuestions.forEach((q, idx) => {
        if (q.trim() === "") {
          emptyIndices.push(idx + 1);
        }
      });

      if (emptyIndices.length > 0) {
        alert(
          `Please fill in all custom questions. Question${
            emptyIndices.length !== 1 ? "s" : ""
          } ${emptyIndices.join(", ")} ${
            emptyIndices.length !== 1 ? "are" : "is"
          } empty.`
        );
        return;
      }
    }
    RecuiterStore.setTechnicalInterviewDetails(
      "technicalInterviewType",
      interviewType
    );

    if (interviewType === "AI interview") {
      RecuiterStore.setTechnicalInterviewDetails("interviewId", 2);
    } else {
      RecuiterStore.setTechnicalInterviewDetails("interviewId", 12);
    }
    RecuiterStore.setTechnicalInterviewDetails(
      "technicalNumberOfQuestions",
      noOfQuestions
    );
    RecuiterStore.setTechnicalInterviewDetails(
      "technicalInterviewLevel",
      level
    );
    RecuiterStore.setTechnicalInterviewDetails(
      "technicalCustomquestions",
      customQuestions
    );
    RecuiterStore.setTechnicalInterviewDetails("technology", technology);
    RecuiterStore.settechnicalAdditionalSettings("attempts", attempts);
    RecuiterStore.setTechnicalInterviewDetails(
      "noOfCustomQuestions",
      noOfCustomQuestions || 0
    );

    CommonStore.setProgress(interview ? 1 : 4);
    CommonStore.setLabelActive(interview ? 0 : 3, true);
    RecuiterStore.setTechnicalInterviewDetails("skipped", false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (noOfQuestions < 1) {
      return alert("Please enter number of questions");
    }

    // Validate custom questions for AI interviews
    if (
      interviewType === "AI interview" &&
      Number(noOfCustomQuestions || 0) > 0
    ) {
      const customCount = Number(noOfCustomQuestions || 0);

      // Check if length matches
      if (customQuestions.length !== customCount) {
        alert(
          `Please provide exactly ${customCount} custom question${
            customCount !== 1 ? "s" : ""
          }. Currently you have ${customQuestions.length} question${
            customQuestions.length !== 1 ? "s" : ""
          }.`
        );
        return;
      }

      // Check if all custom questions are filled
      const emptyIndices = [];
      customQuestions.forEach((q, idx) => {
        if (q.trim() === "") {
          emptyIndices.push(idx + 1);
        }
      });

      if (emptyIndices.length > 0) {
        alert(
          `Please fill in all custom questions. Question${
            emptyIndices.length !== 1 ? "s" : ""
          } ${emptyIndices.join(", ")} ${
            emptyIndices.length !== 1 ? "are" : "is"
          } empty.`
        );
        return;
      }
    }

    setIsLoading(true);
    InterviewStore.setCompanyInterview(true);
    RecuiterStore.setTechnicalInterviewDetails(
      "technicalNumberOfQuestions",
      noOfQuestions
    );
    RecuiterStore.setTechnicalInterviewDetails(
      "technicalInterviewLevel",
      level
    );
    RecuiterStore.setTechnicalInterviewDetails(
      "technicalCustomquestions",
      customQuestions
    );
    RecuiterStore.setTechnicalInterviewDetails("technology", technology);
    RecuiterStore.settechnicalAdditionalSettings("attempts", attempts);
    RecuiterStore.setTechnicalInterviewDetails(
      "technicalInterviewType",
      interviewType
    );
    RecuiterStore.setTechnicalInterviewDetails(
      "noOfIntroQuestions",
      noOfIntroQuestions || 0
    );
    RecuiterStore.setTechnicalInterviewDetails(
      "noOfFollowUps",
      noOfFollowupQuestions || 0
    );
    RecuiterStore.setTechnicalInterviewDetails(
      "allQuestions",
      allQuestions || 0
    );
    RecuiterStore.setTechnicalInterviewDetails(
      "noOfCustomQuestions",
      noOfCustomQuestions || 0
    );
    let resumeLink = null;

    const userDetails = await getUserDataFromLocalStorage();
    let response = null;
    try {
      const customSettings = JSON.parse(localStorage.getItem("customSettings"));
      const id = JSON.parse(localStorage.getItem("interviewId"));
      console.log(userDetails);
      console.log(id);
      const body = {
        userId: userDetails._id,
        attempts: customSettings[3].value,
        invitationFrom: id,
      };
      const setCutOff = (value) => {
        // Define the setCutOff function here
      };

      const setCutOffValue = (value) => {
        setCutOff(value);
        RecuiterStore.setMcqTestDetails("cutOff", value);
      };
      setAttempts(customSettings[3].value);
      response = await apiPostPut(
        body,
        "/interview/validate-custom-settings",
        "POST"
      );
      console.log("validation", response);
    } catch (error) {}

    if (
      userDetails?.role?.role != "company" &&
      userDetails?.role?.role != "consultancy"
    ) {
      // check resume uploaded or not for resume based interview for user or students
      const idOfResumeBasedInterviews = [2, 4, 8];
      if (
        idOfResumeBasedInterviews.includes(
          InterviewStore.interviewSettings?.id ??
            InterviewStore.interviewSettings?.interviewId
        )
      ) {
        if (InterviewStore.resumeFile === null) {
          return alert("Please upload your resume");
        }

        const resumeFileName = Date.now() + InterviewStore.resumeFile?.name;

        const resumeUploadResponse = await uploadFileToAzure(
          resumeFileName,
          InterviewStore.resumeFile,
          { action: "interview" }
        );
        if (resumeUploadResponse?.success) {
          resumeLink = resumeUploadResponse?.url;
        }
      }
    }

    let interviewDetails = {
      // name: name,
      interviewId: getInterviewId(interviewType),
      technology: technology,
      levelOfInterview: level ?? "low",
      noOfQuestions: Number(noOfQuestions),
      noOfIntroQuestions: Number(noOfIntroQuestions || 0),
      noOfFollowUps: Number(noOfFollowupQuestions || 0),
      noOfCustomQuestions: Number(noOfCustomQuestions || 0),
      allQuestions:
        Number(allQuestions || 0) ||
        Number(noOfQuestions || 0) +
          Number(noOfIntroQuestions || 0) +
          Number(noOfFollowupQuestions || 0) +
          Number(noOfCustomQuestions || 0),
      // role: role,
      // company: company,
      customQuestions: customQuestions,
      // resume: InterviewStore.resumeFile,
      resume: InterviewStore.resumeText,
    };
    if (InterviewStore.companyInterview) {
      console.log(
        "companyInterview",
        RecuiterStore.jobPostDetails.technicalInterviewDetails
          .additionalSettings
      );
      interviewDetails.customSettings = [
        {
          name: "video",
          value:
            RecuiterStore.jobPostDetails.technicalInterviewDetails
              .additionalSettings.camera,
        },
        {
          name: "resume",
          value:
            RecuiterStore.jobPostDetails.technicalInterviewDetails
              .additionalSettings.resume,
        },
        {
          name: "screen",
          value:
            RecuiterStore.jobPostDetails.technicalInterviewDetails
              .additionalSettings.screen,
        },
        {
          name: "attempts",
          value:
            RecuiterStore.jobPostDetails.technicalInterviewDetails
              .additionalSettings.attempts,
        },
      ];
      console.log("hello", interviewDetails);
    }
    if (resumeLink !== null) {
      interviewDetails["resumeLink"] = resumeLink;
    }

    console.log(userDetails);
    // return;

    if (
      userDetails?.role?.role === "company" ||
      userDetails?.role?.role === "consultancy"
    ) {
      // InterviewStore.changeInterviewIdByIdForResume(
      //   InterviewStore.interviewSettings?.id
      // );
      interviewDetails["interviewer"] = userDetails?._id;
      interviewDetails["interviewType"] = "real";
      InterviewStore.updateInterviewDetails(interviewDetails);

      let body = {
        ...InterviewStore.interviewSettings,
        isInvitation: true,
        model: 3,
        whoPay: !RecuiterStore.jobPostDetails.technicalInterviewDetails
          .whoPayCheck
          ? "company"
          : "candidate",
      };

      delete body.id;

      console.log(body);
      if (RecuiterStore.clientId) {
        body.client = RecuiterStore.clientId;
      }

      setWaiting(true);
      let apiResponse = null;
      if (id) {
        apiResponse = await apiPostPut(
          body,
          `/interview/update-interview/${id}`,
          "PUT"
        );
      } else {
        apiResponse = await apiPostPut(
          body,
          "/interview/interview-invitation",
          "POST"
        );
      }
      setWaiting(false);
      setIsLoading(false);
      console.log(apiResponse);
      if (apiResponse.body?.success) {
        alert("Interview-invitation created successfully");

        CommonStore.setProgress(2);

        console.log(apiResponse.body?.data?.interviewLink);
        setInvitationLink(
          `https://${getDomainForWhiteLabeling()}/share?page=interview_invitation&id=${
            apiResponse.body?.data?._id
          }`
        );
        setClientLink(
          `https://${getDomainForWhiteLabeling()}/share/applicants?id=${
            apiResponse.body?.data?._id
          }`
        );
        setPopupVisible(true);
      } else {
        alert(apiResponse?.body?.message);
      }

      return;
    }

    // localStorage.setItem("interviewDetails", JSON.stringify(interviewDetails));
    InterviewStore.updateInterviewDetails(interviewDetails);
    console.log(InterviewStore.interviewDetails);
    // navigate(
    //   `/interview?name=${name}&technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}`
    // );
    // Construct the new URL
    const newURL = `/interview?technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}`;

    // Set the new URL and trigger a reload
    console.log(response);
    console.log(InterviewStore.companyInterview, "companyInterview");

    if (!InterviewStore.validation) {
      window.location.href = newURL;
      return;
    }
    if (response.status === 200) {
      window.location.href = newURL;
    } else {
      alert(response.body.message);
    }
  };

  const enableFieldByRole = () => {
    const role = getUserRoleFromLocalStorage();

    console.log(role);

    if (role === null) return;

    InterviewStore.enableInterviewFormById(getInterviewId(interviewType), role);

    switch (role) {
      case "company":
      case "consultancy":
        console.log(InterviewStore.interviewSettings?.id);
        InterviewStore.setShowCustomQuestions();
        // InterviewStore.changeInterviewIdByIdForResume(
        //   InterviewStore.interviewSettings?.id
        // ); // this will enable resume based interview by default

        break;

      default:
        break;
    }
  };

  const consoleMobxFields = () => {
    console.log(InterviewStore.showTechnology);
    console.log(InterviewStore.showName);
    console.log(InterviewStore.showInterviewLevel);
    console.log(InterviewStore.showNoOfQuestions);
  };

  useEffect(() => {
    console.log("form opened 💥", InterviewStore.interviewSettings.interviewId);

    enableFieldByRole();
    consoleMobxFields(); // remove this later

    return () => {
      InterviewStore.resetInterviewFields();
    };
  }, []);

  const setCutOffValue = (value) => {
    RecuiterStore.setTechnicalInterviewDetails("resumeCutoff", value);
  };

  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = invitationLink;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    window.alert("Technical interview link copied");
  };

  const link = () => {
    if (!invitationLink || !clientLink) {
      return {
        jobPostLink: "Interview link not available yet",
        clientLink: "Interview link not available yet",
      };
    }
    const jobPostLink = invitationLink;
    return { jobPostLink: jobPostLink, clientLink: clientLink };
  };

  return useObserver(() => (
    <>
      <HelpCenter />
      {isLoading && <Loader loader={true} text={"Loading..."} />}
      <div
        className={`w-full overflow-hidden ${
          !showSkip ? " flex flex-col items-center justify-center" : null
        } `}
      >
        <div
          className={` w-[90%] mx-auto flex ${
            showSkip ? "justify-between" : "justify-center"
          }`}
        >
          {/* {showSkip && <p></p>} */}
          {!interview && (
            <p className="text-xl font-semibold  mt-10 text-black md:block lg:block md:ml-8">
              {fromIndex ? (id ? "Update" : "Create") : "Add"} Technical
              Interview
            </p>
          )}
          {showSkip && (
            <>
              {RecuiterStore.jobPostDetails.technicalInterviewDetails.skipped &&
              isEdit ? (
                <div className="flex gap-2 flex-col">
                  <button
                    type="button"
                    // onClick={() => setShowPopup(true)}
                    className="text-gray-400 underline cursor-not-allowed mt-20"
                  >
                    Skip Section
                  </button>
                  <p className="text-primary">This section is skipped</p>
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => setShowPopup(true)}
                  className="text-primary underline mt-10 font-bold"
                >
                  Skip Section
                </button>
              )}
            </>
          )}
        </div>
        {/* <p className="text-xl font-semibold md:hidden lg:hidden block text-center text-primary">
          {fromIndex ? "Create" : "Add"} Technical Interview
        </p> */}

        <form
          onSubmit={(e) => {
            e.preventDefault();
            JSON.parse(localStorage.getItem("user"))?.isAccountVerified
              ? fromIndex
                ? handleSubmit(e)
                : handleTechnicalSubmit(e)
              : PopupStore.setVerify(true);
          }}
          className="md:w-[95%] lg:w-[90%] w-[90%] mx-auto mt-4"
        >
          {/* Form Fields Container */}
          <div className="flex flex-wrap md:w-[90%] lg:w-[90%] md:mx-auto lg:mx-auto gap-x-5 md:gap-6">
            {/* First Row - Three Boxes */}
            <div className="md:w-[30%] lg:w-[30%] w-full">
              <Select
                label="Type of Interview"
                required={true}
                placeholder="Select Interview Type AI Interview/Manual Interview"
                value={interviewType}
                action={(e) => {
                  if (
                    RecuiterStore.jobPostDetails.technicalInterviewDetails
                      .skipped
                  ) {
                    RecuiterStore.setTechnicalInterviewDetails(
                      "skipped",
                      false
                    );
                    CommonStore.setLabelSkipped(3, false);
                  }
                  setInterviewType(e.target.value);
                  RecuiterStore.setTechnicalInterviewDetails(
                    "technicalInterviewType",
                    e.target.value
                  );
                  if (e.target.value === "AI interview") {
                    setCustomQuestions([]);
                  }
                }}
                options={[
                  { value: "AI interview", label: "AI-Generated Interview" },
                  { value: "Manual interview", label: "Predefined Interview" },
                ]}
              />
            </div>

            <div className="md:w-[30%] lg:w-[30%] w-full">
              <Input
                label="Topic of Interview (Technology)"
                placeholder="Select Technology Name"
                defaultValue={technology}
                required={true}
                action={(e) => {
                  if (
                    RecuiterStore.jobPostDetails.technicalInterviewDetails
                      .skipped
                  ) {
                    RecuiterStore.setTechnicalInterviewDetails(
                      "skipped",
                      false
                    );
                    CommonStore.setLabelSkipped(3, false);
                  }
                  setTechnology(e.target.value);
                  RecuiterStore.setTechnicalInterviewDetails(
                    "technology",
                    e.target.value
                  );
                }}
              />
            </div>

            <div className="md:w-[30%] lg:w-[30%] w-full">
              <Select
                label="Total Questions"
                placeholder="Select Total Questions"
                value={allQuestions ? String(allQuestions) : ""}
                required={true}
                action={(e) => {
                  if (
                    RecuiterStore.jobPostDetails.technicalInterviewDetails
                      .skipped
                  ) {
                    RecuiterStore.setTechnicalInterviewDetails(
                      "skipped",
                      false
                    );
                    CommonStore.setLabelSkipped(3, false);
                  }
                  const total = Number(e.target.value || 0);
                  setAllQuestions(e.target.value);
                  RecuiterStore.setTechnicalInterviewDetails(
                    "allQuestions",
                    e.target.value
                  );

                  if (interviewType === "Manual interview") {
                    // For Manual, assign all to Topic
                    setNoOfQuestions(String(total));
                    setNoOfIntroQuestions("0");
                    setNoOfFollowupQuestions("0");
                    setNoOfCustomQuestions("0");
                    RecuiterStore.setTechnicalInterviewDetails(
                      "technicalNumberOfQuestions",
                      String(total)
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfIntroQuestions",
                      "0"
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfFollowUps",
                      "0"
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfCustomQuestions",
                      "0"
                    );
                    setShowCustom(false);
                  } else {
                    // For AI, distribute: 60% topic, 20% intro, 20% follow
                    const topic = Math.floor(total * 0.6);
                    const intro = Math.floor(total * 0.2);
                    const follow = Math.max(0, total - topic - intro);

                    // Store original values BEFORE distribution (for cancel)
                    setOriginalTopic(Number(topic || 0));
                    setOriginalIntro(Number(intro || 0));
                    setOriginalFollow(Number(follow || 0));

                    setDistTotal(total);
                    setDistTopic(topic);
                    setDistIntro(intro);
                    setDistFollow(follow);
                    setDistCustom(0);
                    setShowCustom(false);

                    // Update state immediately with distributed values (will update in real-time as user edits)
                    setNoOfQuestions(String(topic));
                    setNoOfIntroQuestions(String(intro));
                    setNoOfFollowupQuestions(String(follow));
                    setNoOfCustomQuestions("0");
                    RecuiterStore.setTechnicalInterviewDetails(
                      "technicalNumberOfQuestions",
                      String(topic)
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfIntroQuestions",
                      String(intro)
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfFollowUps",
                      String(follow)
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfCustomQuestions",
                      "0"
                    );

                    setDistOpen(true);
                  }
                }}
                options={[
                  { value: "5", label: "5 Questions" },
                  { value: "10", label: "10 Questions" },
                  { value: "15", label: "15 Questions" },
                ]}
              />
            </div>

            {/* Question Distribution Display - Only for AI Interview */}
            {allQuestions && interviewType === "AI interview" && (
              <div className="w-full mt-4 md:w-[94%] ">
                <div className="font-semibold mb-2 flex items-center gap-2">
                  Questions Distribution
                </div>
                <div
                  className={`grid grid-cols-1 gap-2 ${
                    showCustom || Number(noOfCustomQuestions || 0) > 0
                      ? "md:grid-cols-4"
                      : "md:grid-cols-3"
                  }`}
                >
                  <div
                    className="flex items-center justify-between p-2 px-4 border rounded-md gap-2 cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={() => {
                      const currentTopic = Number(noOfQuestions || 0);
                      const currentIntro = Number(noOfIntroQuestions || 0);
                      const currentFollow = Number(noOfFollowupQuestions || 0);
                      const currentCustom = Number(noOfCustomQuestions || 0);
                      setDistTotal(Number(allQuestions || 0));
                      setDistTopic(currentTopic);
                      setDistIntro(currentIntro);
                      setDistFollow(currentFollow);
                      setDistCustom(currentCustom);
                      setShowCustom(currentCustom > 0);
                      // Store original values for cancel
                      setOriginalTopic(currentTopic);
                      setOriginalIntro(currentIntro);
                      setOriginalFollow(currentFollow);
                      setDistOpen(true);
                    }}
                    title="Click to adjust question counts"
                  >
                    <span className="text-sm">Topic</span>
                    <div className="flex items-center gap-2">
                      <span className="font-medium">{noOfQuestions || 0}</span>
                      <svg
                        className="w-3 h-3 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between p-2 px-4 border rounded-md gap-2 cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={() => {
                      const currentTopic = Number(noOfQuestions || 0);
                      const currentIntro = Number(noOfIntroQuestions || 0);
                      const currentFollow = Number(noOfFollowupQuestions || 0);
                      const currentCustom = Number(noOfCustomQuestions || 0);
                      setDistTotal(Number(allQuestions || 0));
                      setDistTopic(currentTopic);
                      setDistIntro(currentIntro);
                      setDistFollow(currentFollow);
                      setDistCustom(currentCustom);
                      setShowCustom(currentCustom > 0);
                      // Store original values for cancel
                      setOriginalTopic(currentTopic);
                      setOriginalIntro(currentIntro);
                      setOriginalFollow(currentFollow);
                      setDistOpen(true);
                    }}
                    title="Click to adjust question counts"
                  >
                    <span className="text-sm">Introduction</span>
                    <div className="flex items-center gap-2">
                      <span className="font-medium">
                        {noOfIntroQuestions || 0}
                      </span>
                      <svg
                        className="w-3 h-3 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-between p-2 px-4 border rounded-md gap-2 cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={() => {
                      const currentTopic = Number(noOfQuestions || 0);
                      const currentIntro = Number(noOfIntroQuestions || 0);
                      const currentFollow = Number(noOfFollowupQuestions || 0);
                      const currentCustom = Number(noOfCustomQuestions || 0);
                      setDistTotal(Number(allQuestions || 0));
                      setDistTopic(currentTopic);
                      setDistIntro(currentIntro);
                      setDistFollow(currentFollow);
                      setDistCustom(currentCustom);
                      setShowCustom(currentCustom > 0);
                      // Store original values for cancel
                      setOriginalTopic(currentTopic);
                      setOriginalIntro(currentIntro);
                      setOriginalFollow(currentFollow);
                      setDistOpen(true);
                    }}
                    title="Click to adjust question counts"
                  >
                    <span className="text-sm">Follow Up</span>
                    <div className="flex items-center gap-2">
                      <span className="font-medium">
                        {noOfFollowupQuestions || 0}
                      </span>
                      <svg
                        className="w-3 h-3 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                    </div>
                  </div>
                  {showCustom || Number(noOfCustomQuestions || 0) > 0 ? (
                    <div
                      className="flex items-center justify-between p-2 px-4 border rounded-md gap-2 cursor-pointer hover:bg-gray-50 transition-colors"
                      onClick={() => {
                        const currentTopic = Number(noOfQuestions || 0);
                        const currentIntro = Number(noOfIntroQuestions || 0);
                        const currentFollow = Number(
                          noOfFollowupQuestions || 0
                        );
                        const currentCustom = Number(noOfCustomQuestions || 0);
                        setDistTotal(Number(allQuestions || 0));
                        setDistTopic(currentTopic);
                        setDistIntro(currentIntro);
                        setDistFollow(currentFollow);
                        setDistCustom(currentCustom);
                        setShowCustom(true);
                        // Store original values for cancel
                        setOriginalTopic(currentTopic);
                        setOriginalIntro(currentIntro);
                        setOriginalFollow(currentFollow);
                        setDistOpen(true);
                      }}
                      title="Click to adjust question counts"
                    >
                      <span className="text-sm">Custom</span>
                      <div className="flex items-center gap-2">
                        <span className="font-medium">
                          {noOfCustomQuestions || 0}
                        </span>
                        <svg
                          className="w-3 h-3 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          />
                        </svg>
                      </div>
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="flex items-center justify-center gap-2 p-2 px-4 border border-dashed rounded-md transition-colors hover:bg-gray-50 border-gray-300 hover:border-primary"
                      onClick={() => {
                        const currentTopic = Number(noOfQuestions || 0);
                        const currentIntro = Number(noOfIntroQuestions || 0);
                        const currentFollow = Number(
                          noOfFollowupQuestions || 0
                        );
                        setShowCustom(true);
                        setDistTotal(Number(allQuestions || 0));
                        setDistTopic(currentTopic);
                        setDistIntro(currentIntro);
                        setDistFollow(currentFollow);
                        setDistCustom(0);
                        setDistOpen(true);
                      }}
                      title="Add custom questions"
                    >
                      <svg
                        className="w-4 h-4 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 4v16m8-8H4"
                        />
                      </svg>
                      <span className="text-sm text-gray-600">Custom</span>
                    </button>
                  )}
                </div>
                {(() => {
                  const topicQuestions = Number(noOfQuestions || 0);
                  const introQuestions = Number(noOfIntroQuestions || 0);
                  const followUpQuestions = Number(noOfFollowupQuestions || 0);
                  const customQuestions = Number(noOfCustomQuestions || 0);
                  const total =
                    topicQuestions +
                    introQuestions +
                    followUpQuestions +
                    customQuestions;
                  const selectedTotal = Number(allQuestions || 0);
                  const difference = selectedTotal - total;
                  const isValid = total === selectedTotal;
                  return (
                    <div
                      className={`mt-2 p-2 rounded-md text-sm ${
                        isValid
                          ? "bg-green-50 text-green-700 border border-green-200"
                          : "bg-blue-50 text-blue-700 border border-blue-200"
                      }`}
                    >
                      <div className="flex items-center justify-between">
                        <span>
                          Total: {total} questions
                          {selectedTotal > 0 && ` (Selected: ${selectedTotal})`}
                        </span>
                        {!isValid && selectedTotal > 0 && (
                          <span className="text-xs">
                            {total < selectedTotal
                              ? `${difference} questions available`
                              : `${total - selectedTotal} too many`}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })()}
              </div>
            )}

            {/* Second Row - Aligned Below Corresponding Fields */}

            {/* <div className="md:w-[30%] lg:w-[30%] w-full  mt-3">
              <Input
                label="No. of Attempts"
                type="number"
                defaultValue={
                  RecuiterStore.jobPostDetails.technicalInterviewDetails
                    .additionalSettings.attempts
                }
                action={(e) => {
                  if (
                    RecuiterStore.jobPostDetails.technicalInterviewDetails
                      .skipped
                  ) {
                    RecuiterStore.setTechnicalInterviewDetails(
                      "skipped",
                      false
                    );
                    CommonStore.setLabelSkipped(3, false);
                  }
                  setAttempts(e.target.value);
                  RecuiterStore.settechnicalAdditionalSettings(
                    "attempts",
                    e.target.value
                  );
                }}
              />
            </div> */}
            {interviewType === "AI interview" && (
              <div className="md:w-[30%] lg:w-[30%] w-full mt-3">
                <Select
                  label="Select Level"
                  placeholder="Select Low/Medium/High"
                  value={level}
                  action={(e) => {
                    if (
                      RecuiterStore.jobPostDetails.technicalInterviewDetails
                        .skipped
                    ) {
                      RecuiterStore.setTechnicalInterviewDetails(
                        "skipped",
                        false
                      );
                      CommonStore.setLabelSkipped(3, false);
                    }
                    setLevel(e.target.value);
                    RecuiterStore.setTechnicalInterviewDetails(
                      "technicalInterviewLevel",
                      e.target.value
                    );
                  }}
                  options={[
                    { value: "low", label: "Low" },
                    { value: "medium", label: "Medium" },
                    { value: "high", label: "High" },
                  ]}
                />
              </div>
            )}

            <div className="md:w-[30%] lg:w-[30%] w-full mt-3">
              <PercentageInput
                label="Cut-Off in % (Optional)"
                placeholder="Enter Cut-off Percentage"
                setValue={setCutOffValue}
                defaultValue={
                  RecuiterStore.jobPostDetails.technicalInterviewDetails
                    .resumeCutoff
                }
                tooltip={`If you Set the cut-off Percentage, our AI will analyze resumes based on the JD and filter candidates accordingly`}
                action={(e) => {
                  if (
                    RecuiterStore.jobPostDetails.technicalInterviewDetails
                      .skipped
                  ) {
                    RecuiterStore.setTechnicalInterviewDetails(
                      "skipped",
                      false
                    );
                    CommonStore.setLabelSkipped(3, false);
                  }
                  setCutOffValue(e.target.value);
                  RecuiterStore.setTechnicalInterviewDetails(
                    "resumeCutoff",
                    e.target.value
                  );
                }}
              />
            </div>
          </div>
          {customQuestions?.map((question, index) => (
            <div
              key={index}
              className="flex w-full md:ml-14 mt-6  items-center"
            >
              <div className="w-[90%] ">
                <Input
                  label={`Additional question ${index + 1}`}
                  placeholder="Enter question here"
                  questionMark={true}
                  defaultValue={question}
                  action={(e) => {
                    if (
                      RecuiterStore.jobPostDetails.technicalInterviewDetails
                        .skipped
                    ) {
                      RecuiterStore.setTechnicalInterviewDetails(
                        "skipped",
                        false
                      );
                      CommonStore.setLabelSkipped(3, false);
                    }
                    const newQuestions = [...customQuestions];
                    newQuestions[index] = e.target.value;
                    setCustomQuestions(newQuestions);
                    RecuiterStore.setTechnicalInterviewDetails(
                      "technicalCustomquestions",
                      newQuestions.filter((e) => e !== "")
                    );
                  }}
                />
              </div>
              <div className="flex items-center md:mt-[2%] lg:mt-[2%] mt-[5%] justify-center">
                <MdDeleteOutline
                  onClick={() => handleRemoveQuestion(index)}
                  className="text-xl cursor-pointer ml-3 mt-1 text-primary"
                />
              </div>
            </div>
          ))}

          {/* Add Manual Questions */}
          <button
            onClick={handleAddQuestion}
            type="button"
            className="text-primary flex items-center md:ml-16 mt-8 font-semibold w-[100%] gap-2"
          >
            <MdOutlineAddCircleOutline className="text-2xl" />
            {customQuestions.length === 0
              ? "Add Manual Questions"
              : interviewType !== "pre-defined"
              ? "Add one more question"
              : "Add Manual Questions"}
          </button>

          {/* Form Buttons */}
          <div className="w-[90%] mx-auto mt-10 md:mt-20 flex mb-20 justify-between items-start">
            <button
              type="button"
              className="flex items-center text-primary gap-2 mt-2"
              onClick={() => {
                CommonStore.setProgress(2);
              }}
            >
              <AiOutlineLeft /> Back
            </button>

            <PrimaryButton
              buttonName={"Next"}
              width="w-fit"
              type={
                RecuiterStore.jobPostDetails.technicalInterviewDetails.skipped
                  ? "button"
                  : "submit"
              }
              onClick={() => {
                if (
                  RecuiterStore.jobPostDetails.technicalInterviewDetails.skipped
                ) {
                  CommonStore.setProgress(4);
                  CommonStore.setLabelActive(3, false);
                  CommonStore.setLabelSkipped(3, true);
                } else {
                  CommonStore.setLabelSkipped(3, false);
                }
              }}
              padding={10}
              rounded="lg"
            />
          </div>
        </form>

        {/* Distribution Dialog */}
        {distOpen && interviewType === "AI interview" && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] md:w-[60%] lg:w-[50%] max-w-2xl">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">Distribute Questions</h3>
                <button
                  onClick={() => {
                    setNoOfQuestions(String(originalTopic));
                    setNoOfIntroQuestions(String(originalIntro));
                    setNoOfFollowupQuestions(String(originalFollow));
                    setNoOfCustomQuestions("0");
                    RecuiterStore.setTechnicalInterviewDetails(
                      "technicalNumberOfQuestions",
                      String(originalTopic)
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfIntroQuestions",
                      String(originalIntro)
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfFollowUps",
                      String(originalFollow)
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfCustomQuestions",
                      "0"
                    );
                    setShowCustom(false);
                    setDistOpen(false);
                  }}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <p className="text-sm text-gray-600 mb-4">
                Set Topic, Introduction, Follow Up and Custom counts. Total:{" "}
                {distTotal}
              </p>
              <div
                className={`grid grid-cols-1 gap-3 mb-4 ${
                  showCustom ? "md:grid-cols-4" : "md:grid-cols-3"
                }`}
              >
                <div className="flex flex-col gap-2 p-3 border rounded-md">
                  <label className="text-sm font-medium">Topic</label>
                  <input
                    type="number"
                    min={0}
                    value={distTopic}
                    onChange={(e) => {
                      const newValue = Number(e.target.value || 0);
                      setDistTopic(newValue);
                      // Update state in real-time
                      setNoOfQuestions(String(newValue));
                      RecuiterStore.setTechnicalInterviewDetails(
                        "technicalNumberOfQuestions",
                        String(newValue)
                      );
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                </div>
                <div className="flex flex-col gap-2 p-3 border rounded-md">
                  <label className="text-sm font-medium">Introduction</label>
                  <input
                    type="number"
                    min={0}
                    value={distIntro}
                    onChange={(e) => {
                      const newValue = Number(e.target.value || 0);
                      setDistIntro(newValue);
                      // Update state in real-time
                      setNoOfIntroQuestions(String(newValue));
                      RecuiterStore.setTechnicalInterviewDetails(
                        "noOfIntroQuestions",
                        String(newValue)
                      );
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                </div>
                <div className="flex flex-col gap-2 p-3 border rounded-md">
                  <label className="text-sm font-medium">Follow Up</label>
                  <input
                    type="number"
                    min={0}
                    value={distFollow}
                    onChange={(e) => {
                      const newValue = Number(e.target.value || 0);
                      setDistFollow(newValue);
                      // Update state in real-time
                      setNoOfFollowupQuestions(String(newValue));
                      RecuiterStore.setTechnicalInterviewDetails(
                        "noOfFollowUps",
                        String(newValue)
                      );
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                  />
                </div>
                {showCustom ? (
                  <div className="flex flex-col gap-2 p-3 border rounded-md">
                    <label className="text-sm font-medium">Custom</label>
                    <input
                      type="number"
                      min={0}
                      value={Number(noOfCustomQuestions || 0)}
                      onChange={(e) => {
                        const newValue = Number(e.target.value || 0);
                        setDistCustom(newValue);
                        // Update state in real-time
                        setNoOfCustomQuestions(String(newValue));
                        RecuiterStore.setTechnicalInterviewDetails(
                          "noOfCustomQuestions",
                          String(newValue)
                        );
                      }}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                    />
                  </div>
                ) : (
                  <button
                    type="button"
                    className="flex items-center justify-center gap-2 p-3 border border-dashed rounded-md transition-colors hover:bg-gray-50 border-gray-300 hover:border-primary"
                    onClick={() => setShowCustom(true)}
                  >
                    <svg
                      className="w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                    <span className="text-sm text-gray-600">Custom</span>
                  </button>
                )}
              </div>
              <div className="text-xs text-gray-500 mb-4">
                Remaining:{" "}
                {Math.max(
                  0,
                  distTotal -
                    (Number(noOfQuestions || 0) +
                      Number(noOfIntroQuestions || 0) +
                      Number(noOfFollowupQuestions || 0) +
                      Number(noOfCustomQuestions || 0))
                )}
              </div>
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => {
                    // Revert to original values on cancel
                    setNoOfQuestions(String(originalTopic));
                    setNoOfIntroQuestions(String(originalIntro));
                    setNoOfFollowupQuestions(String(originalFollow));
                    setNoOfCustomQuestions("0");
                    RecuiterStore.setTechnicalInterviewDetails(
                      "technicalNumberOfQuestions",
                      String(originalTopic)
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfIntroQuestions",
                      String(originalIntro)
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfFollowUps",
                      String(originalFollow)
                    );
                    RecuiterStore.setTechnicalInterviewDetails(
                      "noOfCustomQuestions",
                      "0"
                    );
                    setShowCustom(false);
                    setDistOpen(false);
                  }}
                  className="px-4 py-2 border rounded-md hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    const topic = Number(noOfQuestions || 0);
                    const intro = Number(noOfIntroQuestions || 0);
                    const follow = Number(noOfFollowupQuestions || 0);
                    const custom = Number(noOfCustomQuestions || 0);
                    const sum = topic + intro + follow + custom;
                    if (
                      sum !== distTotal ||
                      topic < 0 ||
                      intro < 0 ||
                      follow < 0 ||
                      custom < 0
                    ) {
                      alert("Counts must sum to total and be non-negative.");
                      return;
                    }
                    // Keep custom visible if it was already shown or if value is > 0
                    setShowCustom(custom > 0 || showCustom);
                    // Values are already updated in real-time, just close the dialog
                    setDistOpen(false);
                  }}
                  className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        )}

        {showPopup && (
          // <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          //   <div className="bg-[#F3F3F3] p-6 rounded-lg shadow-lg w-[85%] md:w-[30%] lg:w-[30%] ">
          //     <div className="flex flex-col items-center">
          //       <MdWarning className="text-3xl text-gray-500" />
          //       <p className="mt-4">Please fill in the details to move to the next section / click on skip section</p>
          //     </div>
          //     <div className="mt-6 w-[60%] mx-auto flex justify-between">
          //       <button
          //         className="underline"
          //         onClick={() => {
          //           RecuiterStore.setTechnicalInterviewDetails("skipped", true);
          //           setShowPopup(false);
          //           CommonStore.setProgress(3);
          //           CommonStore.setLabelActive(2, false);
          //         }}
          //       >
          //         Skip Section
          //       </button>
          //       <button className="text-primary underline" onClick={() => setShowPopup(false)}>
          //         Fill details
          //       </button>
          //     </div>
          //   </div>
          // </div>
          <Popup
            onSkip={() => {
              RecuiterStore.setTechnicalInterviewDetails("skipped", true);
              setShowPopup(false);
              CommonStore.setProgress(4);
              CommonStore.setLabelActive(3, false);
              CommonStore.setLabelSkipped(3, true);
            }}
            onFillDetails={() => setShowPopup(false)}
          />
        )}
        {invitationLink !== null && !waiting && popUpVisible && (
          // <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center gap-8 bg-gray-500 bg-opacity-20 z-50">
          //   <div className="bg-white p-4 py-10 relative flex items-center justify-center w-[90%] md:w-[40%] lg:w-[40%]">
          //     <AiOutlineClose
          //       onClick={() => setWaiting(true)}
          //       className="absolute right-2 top-2 cursor-pointer"
          //     />
          //     <div className="flex flex-col w-full">
          //       <label className="text-primary text-xl pb-2">
          //         Copy the link
          //       </label>
          //       <textarea
          //         className="w-full h-auto p-2 focus:outline-none rounded-lg bg-gray-200"
          //         value={invitationLink}
          //       />
          //     </div>
          //     <span
          //       className="flex text-gray-800 cursor-pointer w-5 h-5 md:mt-[4%] lg:mt-[4%] mt-[5%]  hover:text-gray-400 duration-200"
          //       onClick={handleCopyClick}>
          //       {" "}
          //       <AiOutlineCopy className="text-xl active:text-primary" />
          //     </span>
          //   </div>
          // </div>
          <JobShare
            link={link()}
            emailBody={`Here is the interview link : ${invitationLink}`}
            isEdit={id ? true : false}
            emailSubject={""}
            isPopupVisible={popUpVisible}
            handlePopUpVisible={handlePopUpVisible}
            interview="Technical Interview"
          />
        )}
      </div>
    </>
  ));
}
